import { defineStore } from "pinia";
import { ref, readonly } from "vue";

export const useAvailableProgramsStore = defineStore("availablePrograms", () => {
    const availablePrograms = ref([]);

    // update stored available programs
    function updateAvailablePrograms(newAvailablePrograms) {
        availablePrograms.value = newAvailablePrograms;
    }

    return { availablePrograms: readonly(availablePrograms), updateAvailablePrograms };
});
